import { render, staticRenderFns } from "./Release540Sections.vue?vue&type=template&id=1f3e7218&scoped=true&"
import script from "./Release540Sections.vue?vue&type=script&lang=js&"
export * from "./Release540Sections.vue?vue&type=script&lang=js&"
import style0 from "./Release540Sections.vue?vue&type=style&index=0&id=1f3e7218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3e7218",
  null
  
)

export default component.exports